import React, { useEffect, useState } from "react";
import { HTTP } from "../../api/resources";
import Select from "react-select";

export default function UserGroupForm({user, allGroups, project = false, community = false, communityGroups = [], hasEditPermission = true}) {
  const [editGroups, setEditGroups] = useState([]);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectOptions, setSelectOptions] = useState(null);
  const [unsavedIds, setUnsavedIds] = useState([])

  useEffect(() => {
    initializeComponent()
  }, []);

  const initializeComponent = async () => {
    await updateCurrentGroups()

    setUnsavedIds([])
  }

  const updateCurrentGroups = async () => {
    if (!community) {
      setEditGroups(user.team_groups);
      let updatedOptions = _.differenceWith(allGroups, user.team_groups, (a, b) => a.id == b.id)
      updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
      setSelectOptions(updatedOptions)
    } else {
      setEditGroups(communityGroups)
      let updatedOptions = _.differenceWith(allGroups, communityGroups, (a, b) => a.id == b.id)
      updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
      setSelectOptions(updatedOptions)
    }

    return true
  }

  const addGroup = () => {
    if (selectedGroup) {
      unsavedIds.push(selectedGroup.id)
      let index = _.findIndex(editGroups, {id: selectedGroup.id})

      if (index < 0) {
        selectedGroup.not_saved = true
        setEditGroups(state => [...state, selectedGroup])
      }
    }
    setSelectedGroup(null)
    removeSelectOption(selectedGroup)
  }

  const removeArray = (id) => {
    if (id < 0) return undefined
    for (let i = 0; i < unsavedIds.length; i++) {
      let arrValue = unsavedIds[i]
      if (arrValue == id) {
        unsavedIds.splice(i, 1)
      }
    }
  }

  const removeGroup = (group) => {
    if (!project) {
      if (window.confirm('Are you sure you want to remove this group?'))
        if (community) removeMembers(group)
        if (!community && !project) removeGroupFromUser(group)
      else {
        return
      }
    }
    const updatedGroups = _.reject(editGroups, (g) => g.id == group.id);
    setEditGroups(updatedGroups)
    addSelectOption(group)
    removeArray(group.id)
  }

  const removeMembers = async (group) => {
    setSaving(true)
    HTTP.delete(`/groups/${user.id}/${group.id}/delete?type=community`).then(response => {
      setSaving(false);
      Alert.show('notice', 'Group and members removed');
      setTimeout(() => {window.location.reload()}, 1000)
    }).catch(e => {
      setSaving(false);
      Alert.show('error', 'Groups not removed! Try again or refresh.');
    })
  }

  const removeGroupFromUser = async (group) => {
    setSaving(true)
    HTTP.delete(`/groups/${user.id}/${group.id}/delete?type=user`).then(response => {
      setSaving(false);
      Alert.show('notice', 'User removed from group');
    }).catch(e => {
      setSaving(false);
      Alert.show('error', 'User not removed! Try again or refresh.');
    })
  }

  const save = () => {
    setSaving(true);
    let type = 'user'
    if (project) type = 'project'
    if (community) type = 'community'
    const data = { groups: editGroups, type: type }


    HTTP.patch(`/groups/${user.id}/update`, data).then(response => {
        setUnsavedIds([])
        setSaving(false);
        setEditGroups(response.data);
        Alert.show('notice', 'Groups saved!');
        if (community) setTimeout(() => {window.location.reload()}, 1000)
      }).catch(e => {
        setSaving(false);
        Alert.show('error', 'Groups not saved! Try again or refresh.');
      })
  }

  const initializeSelectOptions = () => {
    let updatedOptions = _.differenceWith(allGroups, editGroups, (a, b) => a.id == b.id)
    updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  const addSelectOption = (option) => {
    let updatedOptions = [...selectOptions, option]
    updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  const removeSelectOption = (option) => {
    let updatedOptions = _.reject(selectOptions, (a) => a.id == option.id)
    updatedOptions = _.orderBy(updatedOptions, ['name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  // remove unsaved from list
  const cleanList = () => {
    if (unsavedIds.length > 0) {
    for (let num = 0; unsavedIds.length > num; num++) {
      let unsaved = unsavedIds[num]
      for (let x = 0; editGroups.length > x; x++) {
        if (unsaved == editGroups[x].id) {
          editGroups.splice(x, 1)
        }
      }
    }
    }
  }

  const clearComp = () => {
    setEditing(false)
    if(unsavedIds.length > 0)  Alert.show('notice', `${unsavedIds.length} unsaved groups has been removed from the list`)
    cleanList()
    setUnsavedIds([])
    initializeSelectOptions()
  }

  return(
    <div id="user-group-form" className="card">
      <div className="card-header flex-header">
        <div>
          <h4 className="card-title">Groups</h4>
        </div>
        <div>
          {editing && hasEditPermission && (
            <div>
              <button onClick={clearComp} name="button" className="btn btn-outline-danger mr-1">
                Close
              </button>
              <button onClick={save} name="button" className="btn btn-primary">
                {saving && (<i className="fa fa-spinner-third fa-spin mr-2"></i>)}
                Save
              </button>
            </div>
          )}
          {!editing && hasEditPermission && (
            <button onClick={() => setEditing(true)} className="btn btn-primary"> Edit Groups</button>
          )}
        </div>
      </div>

      {editing && (
        <div className="form-group">
          <label>Add Groups</label>
          <div className="input-group">
            <Select
              className="form-control select-groups"
              classNamePrefix="select-groups"
              onChange={(group) =>
                setSelectedGroup(group)
              }
              options={selectOptions}
              getOptionLabel={group => `${group.name}` }
              getOptionValue={group => group.id}
              value={selectedGroup}
            />
            <div className="input-group-append">
              <button onClick={() => addGroup()} className="btn btn-primary">Add</button>
            </div>
          </div>
        </div>
      )}

      <div className="list-group list-group-flush">
        {editGroups.map((group) => (
          <div key={group.id} id={`group-table-${group.id}`} className="list-group-item">
            <div className='list-group-item-body'>
              <div className='list-group-item-body-main mb-2'>
                <span className="mr-1">{group.name}</span>
              </div>
            </div>
            {editing && (<div className='list-group-item-actions d-none-mobile'>
              { group.not_saved && (<span className="badge badge-sm badge-warning badge-pill mr-2">Not Saved</span>)}

              <button
                onClick={() => removeGroup(group)}
                className="btn btn-sm btn-danger">Remove</button>
            </div>
            )}

          </div>)
        )}
      </div>
    </div>
  );
}
